/**
 * Case screen layout while a document editor is in edit mode.
 */
export const DOCUMENT_EDITOR_EDIT_LAYOUTS = ['FOCUS', 'NONE'] as const;

export type DocumentEditorEditLayout =
  (typeof DOCUMENT_EDITOR_EDIT_LAYOUTS)[number];

export const DEFAULT_DOCUMENT_EDITOR_EDIT_LAYOUT: DocumentEditorEditLayout =
  'NONE';

export function isDocumentEditorEditLayout(
  value: unknown,
): value is DocumentEditorEditLayout {
  return (
    typeof value === 'string' &&
    (DOCUMENT_EDITOR_EDIT_LAYOUTS as readonly string[]).includes(value)
  );
}

/**
 * Zoom a document editor switches to in edit mode: fit the page width, or a
 * whole-number percent
 */
export const DOCUMENT_EDITOR_FIT_PAGE_WIDTH = 'FIT_PAGE_WIDTH';
export const DOCUMENT_EDITOR_EDIT_ZOOM_MIN_PERCENT = 10;
export const DOCUMENT_EDITOR_EDIT_ZOOM_MAX_PERCENT = 500;

export type DocumentEditorEditZoom =
  | typeof DOCUMENT_EDITOR_FIT_PAGE_WIDTH
  | number;

export const DEFAULT_DOCUMENT_EDITOR_EDIT_ZOOM: DocumentEditorEditZoom =
  DOCUMENT_EDITOR_FIT_PAGE_WIDTH;

export function isDocumentEditorEditZoom(
  value: unknown,
): value is DocumentEditorEditZoom {
  if (value === DOCUMENT_EDITOR_FIT_PAGE_WIDTH) return true;
  return (
    Number.isInteger(value) &&
    (value as number) >= DOCUMENT_EDITOR_EDIT_ZOOM_MIN_PERCENT &&
    (value as number) <= DOCUMENT_EDITOR_EDIT_ZOOM_MAX_PERCENT
  );
}

/** The fixed zoom percent to edit at, or null to fit the page width. */
export function editZoomPercent(zoom: DocumentEditorEditZoom): number | null {
  return zoom === DOCUMENT_EDITOR_FIT_PAGE_WIDTH ? null : zoom;
}
